import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Transition } from 'react-transition-group'; // This Component to control
// a specific type of animated motion.
// It rotates, fades in, and scales in a wrapper
// for the provided children
//
// This Component is opinionated, meaning that
// the timing and values for the three things
// being animated are currently hardcoded in the component

var MotionRotateScaleFade = function MotionRotateScaleFade(_ref) {
  var show = _ref.show,
      children = _ref.children;
  var transition = {
    rotate: {
      out: -90,
      "in": 0,
      time: 300,
      timing: 'cubic-bezier(0.04, 0.5, 0.2, 1.00)'
    },
    scale: {
      out: 0.55,
      "in": 1,
      time: 200,
      timing: 'cubic-bezier(0.07, 0.9, 0.4, 1.00)'
    },
    opacity: {
      out: 0,
      "in": 1,
      time: 100,
      timing: 'linear'
    }
  };
  var styles = {
    rotate: {
      "default": {
        transitionProperty: 'transform',
        transitionDuration: "".concat(transition.rotate.time, "ms"),
        transitionTimingFunction: "".concat(transition.rotate.timing),
        transform: "rotate(".concat(transition.rotate["in"], "deg)")
      },
      entering: {
        transform: "rotate(".concat(transition.rotate.out, "deg)")
      },
      exiting: {
        transform: "rotate(".concat(transition.rotate.out, "deg)")
      }
    },
    scale: {
      "default": {
        transitionProperty: 'transform, opacity',
        transitionDuration: "".concat(transition.scale.time, "ms, ").concat(transition.opacity.time, "ms"),
        transitionTimingFunction: "".concat(transition.scale.timing, ", ").concat(transition.opacity.timing),
        transform: "scale(".concat(transition.scale["in"], ", ").concat(transition.scale["in"], ")"),
        opacity: transition.opacity["in"]
      },
      entering: {
        transform: "scale(".concat(transition.scale.out, ", ").concat(transition.scale.out, ")"),
        opacity: transition.opacity.out
      },
      exiting: {
        transform: "scale(".concat(transition.scale.out, ", ").concat(transition.scale.out, ")"),
        opacity: transition.opacity.out
      }
    }
  };
  return React.createElement(Transition, {
    "in": show // timing exit so that the full outro transitions can run
    // the timings of the transitions are set in inline styles below
    ,
    timeout: {
      exit: Math.max(transition.scale.time, transition.opacity.time, transition.rotate.time)
    },
    mountOnEnter: true,
    unmountOnExit: true
  }, function (state) {
    return React.createElement("div", {
      style: _objectSpread({}, styles.rotate["default"], styles.rotate[state])
    }, React.createElement("div", {
      style: _objectSpread({}, styles.scale["default"], styles.scale[state])
    }, children));
  });
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  MotionRotateScaleFade.propTypes = {
    show: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired
  };
}

export default MotionRotateScaleFade;